import { store } from "./index"

const StoreAdapter = {
    dispatch: (id, params) => {
        store.dispatch(id, params)
    },
    get: (id) => {
        return store.getters[`${id}`]
    },
    modules: {
        AppStore: {
            actions: {
                _loadingOn: "AppStore/_loadingOn",
                _loadingOff: "AppStore/_loadingOff",
                _setMessage: "AppStore/_setMessage",
                _clearMessage: "AppStore/_clearMessage",
                _setRoute: "AppStore/_setRoute",
            },
            getters: {
                isLoggedIn: "AppStore/isLoggedIn",
                authStatus: "AppStore/authStatus",
                _loading: "AppStore/_loading",
                _message: "AppStore/_message",
                _route: "AppStore/_route",
            }
        },
        CajaStore: {
            actions: {
                _setCentrosCostos: "CajaStore/_setCentrosCostos",
                _setTiposDocumento: "CajaStore/_setTiposDocumento",
            },
            getters: {
                _centros_costos: "CajaStore/_centros_costos",
                _tipos_documento: "CajaStore/_tipos_documento",
            }
        },
        OrdenStore: {
            actions: {

            },
            getters: {

            }
        },
        UsuarioStore: {
            actions: {
                setUsuario: "UsuarioStore/setUsuario",
                removeUsuario: "UsuarioStore/removeUsuario",
                loadUsuario: "UsuarioStore/loadUsuario",
            },
            getters: {
                usuario: "UsuarioStore/usuario"
            }
        },
    }
}

export default StoreAdapter